import { orderBy } from "lodash";
import template from "./entity-effective-ranges.html";
import "./entity-effective-ranges.less";
import moment from "moment-timezone";
import {
	FORM_ENTITY_EFFECTIVE_RANGE,
	FORM_ENTITY_EFFECTIVE_RANGES
} from "../../../../../../routes";
import { globs } from "../../../../../../services/globs";
import {
	ActionOrPattern, 
	Any 
} from "../../../../../../services/security/actionScopes";

export function controller(appState, loadingService, api, $uibModal, $logger, toastr, securityService) {
	const ctrl = this;

	ctrl.canAddPattern = globs.entityTypes.byType(ctrl.typeConfig.Code).effective.byCode("*").create;
	ctrl.canUpdateActionOrPattern = (scope) => {
		return !!scope 
			? globs.entityTypes.byType(ctrl.typeConfig.Code).effective.byCode(scope).update 
			: globs.entityTypes.byType(ctrl.typeConfig.Code).effective.byCode("*").update;
	};

	const canUpdateGlob = globs.entityTypes.byType(ctrl.typeConfig.Code).effective.byCode("*").update;
	const canDeleteGlob = globs.entityTypes.byType(ctrl.typeConfig.Code).effective.byCode("*").delete;
	ctrl.canUpdateOrDeleteAnyActionScope = new Any([
		new ActionOrPattern(canUpdateGlob),
		new ActionOrPattern(canDeleteGlob)
	]);
	
	ctrl.$onInit = () => {
		ctrl.effectiveRanges = [];
		ctrl.form = appState.forms.selected;

		const canUpdate = securityService.isPatternAllowed(canUpdateGlob);
		const canDelete = securityService.isPatternAllowed(canDeleteGlob);
		ctrl.numColumns = canDelete && canUpdate ? 6 
			: canDelete || canUpdate ? 5
			: 4;

		loadEffectiveRanges();
	};

	function loadEffectiveRanges() {
		const route = FORM_ENTITY_EFFECTIVE_RANGES(appState.forms.selected.Id, ctrl.entity.Id);

		const promise = api.get(route).then(ranges => {
			ctrl.effectiveRanges = orderBy(ranges, ["AsEarlyAs", "Start"]);
			const now = new Date();
			for(const range of ctrl.effectiveRanges) {
				const start = new Date(range.Start);
				const end = range.End && new Date(range.End);

				if(now < start) {
					range.statusClass = "future";
				}
				else if(end !== undefined && now >= end) {
					range.statusClass = "past";
				}
				else {
					range.statusClass = "current";
				}
			}
			
			return;
		});

		return loadingService.watch(promise);
	}

	ctrl.formatDate = (date) => {
		if(date === undefined) {
			return "";
		}
		return moment(date).format("MM-DD-YYYY hh:mm A Z");
	};

	ctrl.addEffectiveRange = () => {
		const instance = $uibModal.open({
			component: "edit-effective-range-modal",
			backdrop: "static",
			resolve: {
				entity: () => ctrl.entity,
				existing: () => ctrl.effectiveRanges,
				timeMode: () => ctrl.form?.TimeMode?.Code,
				typeConfig: () => ctrl.typeConfig
			}
		});

		return instance.result
			.then(newEffectiveRange => {
				const route = FORM_ENTITY_EFFECTIVE_RANGES(appState.forms.selected.Id, ctrl.entity.Id);
				const promise = ctrl.post(route, newEffectiveRange)
					.then(() => {
						toastr.success("New effective range was added.");

						return loadEffectiveRanges();
					});

				return loadingService.watch(promise);
			})
			.catch(err => !!err && toastr.error(`${ctrl.entity.Name} failed to update.`));
	};

	ctrl.editEffectiveRange = (range) => {
		const instance = $uibModal.open({
			component: "edit-effective-range-modal",
			backdrop: "static",
			resolve: {
				entity: () => ctrl.entity,
				existing: () => ctrl.effectiveRanges,
				range: () => range,
				timeMode: () => ctrl.form?.TimeMode?.Code,
				timeZone: () => ctrl.timeZone,
				typeConfig: () => ctrl.typeConfig
			}
		});

		return instance.result
			.then(updated => {
				const route = FORM_ENTITY_EFFECTIVE_RANGE(appState.forms.selected.Id, ctrl.entity.Id, updated.Id);
				const promise = ctrl.put(route, updated)
					.then(() => {
						toastr.success("Effective range was updated.");

						return loadEffectiveRanges();
					});

				return loadingService.watch(promise);
			});
	};

	ctrl.onUpdate = async() => {
		await loadEffectiveRanges();
	};
}

export default angular.module("vesl.components.entity-effective-ranges", [])
	.component("entityEffectiveRanges", {
		controller,
		template,
		bindings: {
			entity: "<",
			readonly: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
